function loadTrustPilot() {
  const script = document.createElement("script");
  script.src =
    "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
  script.setAttribute("async", "true");
  document.getElementsByTagName("head")[0].appendChild(script);
}

const widgets = document.getElementsByClassName("trustpilot-widget");

if (widgets.length > 0) {
  Defer(loadTrustPilot, 2000, true);
}
